import React, { useEffect, useState } from "react";
import Navbar from "./Navbar";
import { useLocation } from "react-router-dom";
import css from "./header.module.css";
import resources from '../../resources/index'
const Header = () => {

  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false); //use to change bg f header on scroll

  useEffect(() => {
    if (location.pathname === "/home") {
      setIsScrolled(false);
    } else if (location.pathname === "/about") {
      setIsScrolled(true);
    } else if (location.pathname === "/service") {
      setIsScrolled(true);
    } else {
      setIsScrolled(false);
    }
  }, []);
  
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      if (scrollTop > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className={`${css.header}  ${isScrolled ? css.scrolled_header : ''}`}>
      <div className={css.header_img}>
        {!isScrolled ? <img src={resources.icons.logo} alt="LOGO" /> : <img src={resources.icons.logo_scrolled} alt="LOGO" />}
      </div>
      <Navbar isScrolled = {isScrolled} />
    </div>
  );
};

export default Header;
